import React, { useState, useEffect } from 'react';
import {
  Input,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  CloseButton,
  Table
} from 'reactstrap';
import { showAlert, showSuccess } from 'utils/toast';
import { Loader } from 'components';
import { userSelector } from 'features/auth/authSelectors';
import { useSelector } from 'react-redux';
import { fetchSiteConfig } from "api/siteConfigApi";
import { createDepositAccountRequest } from "api/mailApi"
import { createPartnerDeposit } from 'api/partnerDepositApi';

function PartnerDepositModal(props) {
  const currentUser = useSelector(userSelector);
  const [type, setType] = useState('casino');
  const [amount, setAmount] = useState(0);
  const [name, setName] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [config, setConfig] = useState({
    deposit: {
      sports: {
        condition: 0,
        maxAmountPerRequest: 0,
        minAmount: 0,
        unit: 0,
      },
      casino: {
        condition: 0,
        maxAmountPerRequest: 0,
        minAmount: 0,
        unit: 0,
      },
      maxDailyRequest: 1,
      breakTime: {
        startAt: "00:00",
        endAt: "00:00",
      },
      usePassword: true,
      content: "",
      interval: 1,
    },
  });

  const handleSave = async () => {
    // if (!name) {
    //   return showAlert('입금자명을 입력해주세요');
    // }

    if (isNaN(parseFloat(amount))) {
      return showAlert('숫자만 입력 가능합니다');
    }

    if (amount < config.deposit.casino.minAmount) {
      return showAlert(`요청 금액은 최소 ${config.deposit.casino.minAmount.toLocaleString()}원 이상이어야 합니다.`);
    }
  
    // Check casino.unit condition (amount should be a multiple of unit)
    if (config.deposit.casino.unit > 0 && amount % config.deposit.casino.unit !== 0) {
      return showAlert(`요청 금액은 ${config.deposit.casino.unit.toLocaleString()}원 단위로 입력해야 합니다.`);
    }

    setIsLoading(true);

    try {
      const { success, message } = await createPartnerDeposit({ type, name, amount });

      if (!success) throw new Error(message);

      showSuccess('저장되었습니다!');
      setName('');
      setAmount(0);
      props.setIsDeposit(false);
    } catch (error) {
      console.error('Failed to update alarm config:', error);
      showAlert(error.message);
    }

    setIsLoading(false);
  };

  const handleDepositAccountRequest = async () => {
    if(!window.confirm('입금계좌를 문의하시겠습니까?')) return;

    setIsLoading(true);

    try {
      const { success, message } = await createDepositAccountRequest();

      if (!success) throw new Error(message);

      showSuccess('요청이 발송되었습니다!');
    } catch (error) {
      console.error('Failed to send mail:', error);
      showAlert(error.message);
    }

    setIsLoading(false);
  };
  
  const fetchData = async () => {
    setIsLoading(true);
    try {
      if(currentUser?.site) {
        const { success, data, message } = await fetchSiteConfig(currentUser?.site);
  
        if (!success) throw new Error(message);
  
        if (data) {
          setConfig({
            ...data,
            withdrawal: {
              ...config.withdrawal,
              ...data.withdrawal,
            },
          });
        }

      }
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };
  
  useEffect(() => {
    fetchData();
  }, []);

  const quickAmountButtons = [10000, 50000, 100000, 1000000];

  return (
    <Modal
      backdrop={true}
      centered={true}
      isOpen={props.open}
      toggle={() => props.setIsDeposit(!props.open)}
    >
      <ModalHeader
        className="primary-background"
        close={
          <CloseButton
            onClick={() => props.setIsDeposit(false)}
            variant="white"
          />
        }
      >
        파트너 입금 요청
      </ModalHeader>
      <ModalBody>
        {isLoading && <Loader />}
        <div className="text-center">
          <Button
            color="info"
            className="btn-sm"
            onClick={handleDepositAccountRequest}
          >
            입금계좌문의
          </Button>
        </div>
        <Table bordered responsive style={{ marginTop: '2rem' }}>
          <tbody className="align-items-center">
            <tr>
              <td className="form-header text-center align-middle">지갑 유형</td>
              <td>카지노</td>
            </tr>
            <tr>
              <td className="form-header text-center align-middle">입금자명</td>
              <td>                
                <Input
                  type="text"
                  className="form-control-sm input-sm"
                  placeholder="입금자명"
                  value={name}
                  onChange={(e) => {
                    setName(e.target.value);
                  }}
                />
              </td>
            </tr>
            <tr>
              <td className="form-header text-center align-middle">요청 금액</td>
              <td>
                <Input
                  type="number"
                  className="form-control-sm input-sm"
                  placeholder="요청 금액"
                  value={amount}
                  onChange={(e) => {
                    const inputAmount = parseInt(e.target.value, 10);
                    setAmount(isNaN(inputAmount) ? 0 : inputAmount);
                  }}
                />
                <small className="text-muted">최소 금액: ${config.deposit.casino.minAmount.toLocaleString()}원</small>
              </td>
            </tr>
          </tbody>
        </Table>
        <div className="d-flex justify-content-around mt-3">
          {quickAmountButtons.map((value) => (
            <Button
              key={value}
              color="secondary"
              className="btn-sm"
              onClick={() => setAmount((prev) => prev + value)}
            >
              +{value.toLocaleString()}원
            </Button>
          ))}
          <Button color="danger" className="btn-sm" onClick={() => setAmount(0)}>
            초기화
          </Button>
        </div>
      </ModalBody>
      <ModalFooter>
        <Button color="primary" onClick={handleSave}>
          요청
        </Button>{' '}
        <Button color="secondary" onClick={() => props.setIsDeposit(false)}>
          취소
        </Button>
      </ModalFooter>
    </Modal>
  );
}

export default PartnerDepositModal;

